var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof tns3nd !== "undefined") return resolve();
	__webpack_require__.l("//c2.yonyoucloud.com/iuap-3rd-party/ucf-wh/lib3rd/tne3rd-runtime.js", function(event) {
		if(typeof tns3nd !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "tns3nd");
}).then(function() { return tns3nd; });